import { render, staticRenderFns } from "./invoice-orders-table-panel.vue?vue&type=template&id=53a49eda&scoped=true&lang=pug"
import script from "./invoice-orders-table-panel.vue?vue&type=script&lang=js"
export * from "./invoice-orders-table-panel.vue?vue&type=script&lang=js"
import style0 from "./invoice-orders-table-panel.vue?vue&type=style&index=0&id=53a49eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a49eda",
  null
  
)

export default component.exports